import { styled, Grid } from "@mui/material";

export const BreakSpan = styled("span")(({ theme }) => ({
  wordBreak: "break-all",
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightMedium
}));

export const CorrelationSpan = styled("span")(({ theme }) => ({
  wordBreak: "break-all",
  fontWeight: theme.typography.fontWeightMedium,
  cursor: "pointer",
  textDecoration: "underline",
  "&:hover": {
    fontWeight: theme.typography.fontWeightBold
  }
}));

export const LogDetailPre = styled("pre")(() => ({
  whiteSpace: "pre-wrap"
}));

export const LogPropertyContainer = styled(Grid)(() => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
}));
